import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function timeAgo(dateStr: string, short = false): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return 'vừa xong';
  if (minutes < 60) return short ? `${minutes} phút` : `${minutes} phút trước`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return short ? `${hours} giờ` : `${hours} giờ trước`;
  const days = Math.floor(hours / 24);
  return short ? `${days} ngày` : `${days} ngày trước`;
}
